// extracted by mini-css-extract-plugin
export default {"markForReviewContainer":"feed-input_markForReviewContainer__i6tiw","customPluginContainer":"feed-input_customPluginContainer__wl308"};